import type { PermName } from '../../rbac/permissions.js';

/**
 * Palette source keys. Declared here (client-safe: no repo instances, no
 * server imports) and imported BY the server's search-repo.ts as a type-only
 * import, so the two registries can never drift on a key name.
 */
export type SearchSourceKey = 'tenants' | 'businessTypes' | 'users';

export interface PaletteSection {
  key: SearchSourceKey;
  label: string;
  /** Permission name, re-checked when rendering recents. */
  perm: PermName;
}

// Adding a source is ONE entry here plus one in server/search/search-repo.ts.
// This file carries no fetch function and no repo instance -- the client only
// ever calls the single /api/search endpoint.
export const PALETTE_SECTIONS: readonly PaletteSection[] = [
  { key: 'tenants', label: 'Tenants', perm: 'TENANTS_READ' },
  { key: 'businessTypes', label: 'Business Types', perm: 'BUSINESS_TYPES_READ' },
  { key: 'users', label: 'People', perm: 'USERS_READ' },
];
